// extracted by mini-css-extract-plugin
export default {"container":"IncomeStatement_container__uhHeP","tableContainer":"IncomeStatement_tableContainer__Wo43I"};